export { default } from './TypographyWithSkeleton';
